/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import FormattedPriceDisplay from "./formatted-price-display";

export default FormattedPriceDisplay;
